<p-chart [height]="chartHeight" type="bar" [data]="basicData" [options]="basicOptions" class="dash-chart"/>
